import { render, staticRenderFns } from "./TestResult.vue?vue&type=template&id=1a8286d4&scoped=true"
import script from "./TestResult.vue?vue&type=script&lang=js"
export * from "./TestResult.vue?vue&type=script&lang=js"
import style0 from "./TestResult.vue?vue&type=style&index=0&id=1a8286d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8286d4",
  null
  
)

export default component.exports